import React from 'react';
import { SliderContentWrapper, SliderItem, SliderItemDescription, SliderItemImage, SliderItemTitle } from './styles';
import { sliderElements } from './sliderElements';
import MultiStepContent from '../MultiStepContent/MultiStepContent';
export var Slider = function Slider(_ref) {
  var isCSPLiveOnboarding = _ref.isCSPLiveOnboarding,
      currentSlide = _ref.currentSlide,
      onChangeSlide = _ref.onChangeSlide,
      onClose = _ref.onClose,
      onDone = _ref.onDone;
  var items = !isCSPLiveOnboarding ? sliderElements.filter(function (item) {
    return !item.isCSPLive;
  }) : sliderElements;
  return /*#__PURE__*/React.createElement(SliderContentWrapper, null, /*#__PURE__*/React.createElement(MultiStepContent, {
    currentSlide: currentSlide,
    onChangeSlide: onChangeSlide,
    "aria-label": 'Chegg Study Pack onboarding',
    onDone: onDone,
    onClose: onClose,
    buttonDataTestId: "csp-carousel-next-cta",
    progressDataTestId: "csp-carousel-indicator"
  }, items.map(function (_ref2, index) {
    var title = _ref2.title,
        imageUrl = _ref2.imageUrl,
        info = _ref2.info,
        infoSec = _ref2.infoSec;
    return /*#__PURE__*/React.createElement(SliderItem, {
      key: index,
      "data-test": "csp-carousel-item"
    }, /*#__PURE__*/React.createElement(SliderItemTitle, {
      "data-test": "csp-carousel-item-title"
    }, title), /*#__PURE__*/React.createElement(SliderItemImage, {
      src: imageUrl,
      alt: title,
      "data-test": "csp-carousel-item-image"
    }), /*#__PURE__*/React.createElement(SliderItemDescription, {
      "data-test": "csp-carousel-item-info"
    }, info, infoSec && /*#__PURE__*/React.createElement("div", null, infoSec)));
  })));
};
Slider.displayName = 'Slider';
export default Slider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/internals/CSPOnboarding/Slider/Slider.js
// module id = 5591
// module chunks = 11